// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"136":"083f51ef","147":"6c28c37c","162":"2f7407d5","246":"64c3c780","295":"41e827a3","450":"3b1c3f3e","612":"5f84aec1","676":"ae5499d6"}[chunkId] + ".js";
};